angular.module("requestData.components", ['app.services']).component("requestData", {
    templateUrl: "ng/components/variazioneTargato/requestData/requestData.view.html",
    bindings: {
        formIsOk: '&',
        formIsNotOk: '&',
        dettaglioRichiesta: '=',
        readOnly: '<',
        model: "="
    },
    controllerAs: "requestDataCtrl",
    controller: function RequestData(
        $arcService,
        $RichiestePostVenditaService
    ) {
        var self = this;

        self.$onInit = function () {
            $('#accordion').addClass('p-0');
            self.supportModel = {
                selectedVariationType: null,
                vehiclesToModify: [],
                note: self.dettaglioRichiesta.nota,
                selectedNations: self.model.metadata.contrattoTargato.listaNazioniDelega,
                contratti: [],
                selectDeselectAll: {
                    selected: false
                }
            }

            self.cachedVehicleList = [];
            self.getVariationType();
            self.isPending = false;
            self.showStati = false;
            self.societaTerza = false;

            if (!self.readOnly) {
                self.getVehiclesFromContracts();
            }

            self.enableNext();
        };

        self.handleChange = function (type, value) {
            switch (type) {
                case 'variationType':
                    if (value) {
                        self.supportModel.selectedVariationType = value;
                        self.dettaglioRichiesta.tipoVar = self.supportModel.selectedVariationType.value;
                        self.dettaglioRichiesta.descVar = self.supportModel.selectedVariationType.name;

                        if (value.value === "CUE" || value.value === "EUE") {
                            self.showStati = true;
                            getNazioni(value.value);
                        } else {
                            self.showStati = false;
                            self.supportModel.selectedNations = [];
                            self.model.metadata.contrattoTargato.listaNazioniDelega = [];
                        }

                        if (value.value === "RSL" || value.value === "RCO" || value.value === "RNO") {
                            self.societaTerza = true;
                        } else {
                            self.societaTerza = false;
                            self.model.metadata.contrattoTargato.ragSocSocietaTerza = null;
                            self.model.metadata.contrattoTargato.sedeSocietaTerza = null;
                        }
                    } else {
                        self.supportModel.selectedVariationType = null;
                        self.societaTerza = false;
                        self.model.metadata.contrattoTargato.ragSocSocietaTerza = null;
                        self.model.metadata.contrattoTargato.sedeSocietaTerza = null;
                        self.showStati = false;
                        self.supportModel.selectedNations = [];
                        self.model.metadata.contrattoTargato.listaNazioniDelega = [];
                    }
                    break;
                case 'nation':
                    self.supportModel.selectedNations = value;
                    self.model.metadata.contrattoTargato.listaNazioniDelega = self.supportModel.selectedNations;
                    break;
                case 'ragSocSocietaTerza':
                    self.model.metadata.contrattoTargato.ragSocSocietaTerza = value;
                    break;
                case 'sedeSocietaTerza':
                    self.model.metadata.contrattoTargato.sedeSocietaTerza = value;
                    break;
                case 'note':
                    self.model.metadata.contrattoTargato.nota = value;
                    break;
                default:
                    break;
            }
            self.enableNext();
        }

        self.getVariationType = function () {
            $RichiestePostVenditaService
                .subprocessList(self.model.type, self.model.subtype)
                .then(function (response) {
                    if (response.success) {
                        self.variationTypeDropDown = response.domainList;
                        if (self.dettaglioRichiesta.tipoVar && self.dettaglioRichiesta.descVar) {
                            self.variationTypeDropDown.forEach(function (variationType) {
                                if (self.dettaglioRichiesta.tipoVar === variationType.value &&
                                    self.dettaglioRichiesta.descVar === variationType.name) {
                                    self.selectedVariation = variationType;
                                    self.handleChange('variationType', variationType);
                                }
                            })
                        }
                    }
                    self.enabledLoader = false;

                }).catch(function (error) {
                    console.log(error);
                    self.enabledLoader = false;
                });
        };

        self.onCheckboxChange = function (el) {
            el.selected = !el.selected;
            self.model.metadata.contrattoTargato.contratti.forEach(function (contratto) {
                contratto.listDettaglioTargato.forEach(function (bene) {
                    if (bene.idBene === el.id) {
                        bene.selected = el.selected;
                    }
                })

            })
            self.enableNext();
        }

        self.selectedDeselectedAll = function (checkbox) {
            checkbox.selected = !checkbox.selected;
            self.supportModel.contratti.forEach(function (contratto) {
                contratto.selected = checkbox.selected;
            })
            self.model.metadata.contrattoTargato.contratti.forEach(function (contratto) {
                contratto.listDettaglioTargato.forEach(function (bene) {
                    bene.selected = checkbox.selected;
                })

            })
            self.enableNext();
        }

        self.getVehiclesFromContracts = function () {
            self.isPending = true;
            $arcService
                .getVehicles(self.model.metadata.contrattoTargato.contratti)
                .then(function (response) {
                    self.model.metadata.contrattoTargato.contratti.forEach(function (contratto) {
                        response.contratti.forEach(function (element) {
                            if (contratto.numero === element.numero && contratto.modulo === element.modulo) {
                                contratto.listDettaglioTargato = element.listDettaglioTargato;
                                self.supportModel.contratti = self.supportModel.contratti.concat(element.listDettaglioTargato.map(function (dettaglio) {
                                    return {
                                        id: dettaglio.idBene,
                                        numero: contratto.numero,
                                        modulo: contratto.modulo,
                                        selected: dettaglio.selected,
                                        dscProdotto: contratto.dscProdotto,
                                        importo: contratto.importo,
                                        targa: dettaglio.targa,
                                        telaio: dettaglio.telaio

                                    }
                                }))
                            }


                        });
                    });
                    self.isPending = false;
                    self.enableNext();
                })
                .catch(function (error) {
                    console.log("ERROR: ", error);
                })
                .finally(function () {
                    self.isPending = false;
                })
        }

        self.enableNext = function () {
            var testContratto = false;
            var testNations = false;
            var testSocTerza = false;

            testContratto = self.supportModel.contratti.some(function (element) {
                return element.selected == true
            });

            testNations = self.showStati ? self.model.metadata.contrattoTargato.listaNazioniDelega.length > 0 : true;
            testSocTerza = self.societaTerza ? self.model.metadata.contrattoTargato.ragSocSocietaTerza && self.validitySede : true;

            if (self.supportModel && self.supportModel.selectedVariationType &&
                testContratto && testNations && testSocTerza) {
                self.formIsOk();
            } else {
                self.formIsNotOk();
            }
        }

        var getNazioni = function (value) {
            var nazioniIncluse = [];
            var nazioniEscluse = [];
            if (value === "CUE") {
                nazioniIncluse.push("UE");
            } else {
                nazioniEscluse.push("UE");
            }

            $RichiestePostVenditaService.getNazioniWithFilters(nazioniIncluse, nazioniEscluse)
                .then(function (response) {
                    self.nationsList = response.domainList;

                    self.nationsList = self.nationsList.filter(
                        function (elem) {
                            return elem.name != "ITALIA";
                        }
                    );
                })
        };

        self.exportValiditySede = function (validity) {
            self.validitySede = validity;
        }

    }
});